import { Observable } from 'rxjs';
import { EntityId } from '@shared/core/types';
import { MailMessage, MailThread } from '../types';

export abstract class MailComponentService {
  abstract loadThread(messageSnippetId: EntityId): void;
  abstract getThread(messageSnippetId: EntityId): Observable<MailThread>;

  abstract loadMessage(messageId: EntityId): void;
  abstract getMessage(messageId: EntityId): Observable<MailMessage>;

  abstract markMessageAsRead(messageId: EntityId): void;
}
